export const calculatorsData = [
  {
    id: 1,
    calculatorName: "Debt Consolidation Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/debt-consolidation-1738049469538.webp",
    link: "/calculators/debt-consolidation-calculators/debt-consolidation-calculator",
  },
  {
    id: 2,
    calculatorName: "Personal Loan Debt Consolidation Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-debt-consolidation-1738050351654.webp",
    link: "/calculators/debt-consolidation-calculators/debt-consolidation-for-personal-loan-calculator",
  },
];
